<template>
  <div
      class="p-3 bg-white card multisteps-form__panel border-radius-xl"
      data-animation="FadeIn"
  >
    <h5 class="font-weight-bolder">Video (optional)</h5>
    <div class="multisteps-form__content">
      <div class="mt-3 row">
        <div v-if="uploading" class="col-12">
          <label>Upload Fortschritt: {{progress}}%</label>
          <div class="mx-auto progress">
            <div
                class="progress-bar bg-gradient-success"
                role="progressbar"
                :style="'width: ' + progress + '%;'"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
          </div>
        </div>
        <br>
        <div class="col-12">
          <label>Bitte hier das Video hochladen</label>
          <form
              id="dropzone"
              action="/file-upload"
              class="form-control dropzone"
          >
            <div class="fallback">
              <input name="file" type="file"/>
            </div>
          </form>
        </div>
      </div>
      <div class="mt-4 button-row d-flex col-12">
        <soft-button
            color="secondary"
            variant="gradient"
            class="mb-0 js-btn-prev"
            title="Prev"
            @click="this.$parent.prevStep"
        >Zurück
        </soft-button
        >
        <soft-button
            :is-disabled="uploading"
            type="button"
            color="success"
            variant="gradient"
            class="mb-0 ms-auto js-btn-next"
            title="Erstellen"
            @click="startFileUpload"
        >Hochladen
        </soft-button>
        <soft-button
            type="button"
            color="dark"
            variant="gradient"
            class="mb-0 ms-auto js-btn-next"
            title="Erstellen"
            @click="this.continue()"
        >{{getButtonName()}}
        </soft-button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import Dropzone from "dropzone";
import { toRaw } from "vue";
import cmsService from "@/services/cms.service";

export default {
  name: "CmsMedia",
  components: {
    SoftButton,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dropZone: null,
      uploading: false,
      progress: 0,
      sentBytes: 0,
      completed: false,
    };
  },
  mounted() {
    Dropzone.autoDiscover = false;
    const drop = document.getElementById("dropzone");
    // Dropzone is UI-only; upload uses axios (same as "ohne Video") to avoid extra XHR headers / CORS issues.
    this.dropZone = new Dropzone(drop, {
      addRemoveLinks: true,
      uploadMultiple: false,
      acceptedFiles: "video/*",
      autoProcessQueue: false,
      maxFilesize: 3000,
      url: "/",
    });
  },
  methods: {
    async startFileUpload() {
      if (!this.dropZone || this.dropZone.getAcceptedFiles().length === 0) {
        this.$swal({
          icon: "warning",
          title: "Video-Upload",
          text: "Bitte zuerst eine Videodatei auswählen.",
        });
        return;
      }
      const file = this.dropZone.getAcceptedFiles()[0];
      const raw = toRaw(this.$parent.article);
      const article = {
        articleTitle: raw.articleTitle,
        description: raw.description,
        id: raw.id,
        active: raw.active,
        cmsCategory: this.categoryId,
      };
      this.uploading = true;
      this.progress = 0;
      try {
        const res = await cmsService.createArticle(
          article,
          true,
          file,
          (e) => {
            if (e.total) {
              this.progress = Math.round((e.loaded * 100) / e.total);
            }
          },
        );
        this.$parent.article.id = res.data.id;
        this.progress = 100;
        this.completed = true;
        this.$swal({
          icon: "success",
          title:
            "Der Artikel '" +
            this.$parent.article.articleTitle +
            "' wurde erfolgreich hochgeladen'!",
          text: "Du kannst nun eventuelle Dokumente hochladen.",
          type: "success-message",
        });
      } catch (e) {
        let msg = "Upload fehlgeschlagen";
        if (e.response && e.response.data) {
          const d = e.response.data;
          if (typeof d.data === "string") {
            msg = d.data;
          }
        }
        this.$swal({ icon: "error", title: "Video-Upload", text: msg });
      } finally {
        this.uploading = false;
      }
    },
    async continue() {
      if (this.completed) {
        this.$parent.nextStep();
      } else {
        this.$parent.article.cmsCategory = this.categoryId;
        const response = await cmsService.createArticle(this.$parent.article, false, null);
        this.$parent.article.id = response.data.id;
        this.$swal({
          icon: "success",
          title: "Der Artikel '"+this.$parent.article.articleTitle+"' wurde erfolgreich hochgeladen'!",
          text: "Du kannst nun eventuelle Dokumente hochladen.",
          type: "success-message",
        });
        this.$parent.nextStep();
      }
    },
    getButtonName() {
      if (this.completed) {
        return "WEITER";
      }
      return "WEITER OHNE VIDEO";
    },
  },
};
</script>
